module.exports = __webpack_public_path__ + "img/like空心.52b10684.svg";